<template>
  <div class="virtual-background-installation-block">
    <UiComponentHeading :level="2">
      <slot name="title" />
    </UiComponentHeading>
    <div class="cards">
      <MoleculeInstallationCardStep
        v-for="{ id, image, paragraph, step } in props.cards"
        :key="id"
        :image="image"
      >
        <template #step>
          {{ step }}
        </template>
        <template #paragraph>
          {{ paragraph }}
        </template>
      </MoleculeInstallationCardStep>
    </div>
    <AtomButton
      :action="props.cta.action"
      :to="props.cta.to"
      type="text"
    >
      {{ props.cta.slot }} <UiComponentIcon type="arrow-right" />
    </AtomButton>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  cards: {
    default() {
      return []
    },
    type: Array,
  },
  cta: {
    default() {
      return {}
    },
    type: Object,
  },
})
</script>

<style lang="postcss" scoped>
.virtual-background-installation-block {
  @apply flex flex-col items-center w-full;

  h2 {
    @apply font-normal text-center !important;

    @screen xl {
      width: 840px;
    }

    :deep(strong),
    :deep(b) {
      @apply font-normal text-winter-green-900 !important;
    }
  }

  .cards {
    @apply mt-12 flex flex-col items-center w-full;

    @screen xl {
      @apply flex-row items-start justify-between;
    }

    :deep(.installation-card-step) {
      @apply mt-10 w-full;

      &:first-child {
        @apply mt-0;
      }

      @screen md {
        width: 530px !important;
      }

      @screen xl {
        @apply mt-0;
        width: 400px !important;
      }
    }
  }

  .button {
    @apply mt-12 text-livestorm-blue-700;

    i {
      @apply text-livestorm-blue-700;
    }
  }
}
</style>
